export enum ELoaiTaiKhoan {
  AdminTong = 0,
  ThongThuong = 1,
}

export enum EGioiTinh {
  Nam = 1,
  Nu = 2,
  Khac = 3,
}

export enum ETinhTrangHonNhan {
  DocThan = 0,
  DaKetHonChuaCon = 1,
  DaKetHonMotCon = 2,
  DaKetHonHaiCon = 3,
}

export enum ELoaiHinhNhanVien {
  ThucTap = 1,
  CTV = 2,
  ThuViec = 3,
  ChinhThuc = 4,
}

export enum ETrangThaiNhanVien {
  DaNghiViec = 0,
  DangLamViec = 1,
  HoanLamViec = 2,
}

export enum ELoaiKhenThuongKyLuat {
  KyLuat = 0,
  KhenThuong = 1,
}
export enum ELoaiHopDong {
  HopDongHopTac = 1,
  HopDongLaoDong = 2,
}

export enum EBucketName {
  PUBLIC = 'public',
  PRIVATE = 'private',
}

export enum ELoaiCheDo {
  CheDoPhucLoi = 1,
  CheDoLamViec = 2,
}

export enum ETrangThaiDonXinNghi {
  DangLap = 1,
  ChoDuyet = 2,
  DaDuyet = 3,
}

export enum ETrangThaiTinTuc {
  DangLap = 1,
  ChoPheduyet = 2,
  DaPhatHanh = 3,
}

export enum ETrangThaiKraThang {
  DangLap = 1,
  ChoDuyet = 2,
  DaDuyet = 3,
}

export enum ETrangThaiBaoCaoTuan {
  ChuaLam = 1,
  DangLam = 2,
  HoanThanh = 3,
  HoanThanhMucTieu = 4,
  KhongPhaiMucTieu = 5,
}

export enum ETrangThaiKraThangChiTiet {
  DangLam = 1,
  HoanThanh = 2,
}

export enum EKetQuaKra {
  ChuaHoanThanh = 0,
  HoanThanh = 1,
}

export enum ELoaiKra {
  ChuyenMon = 1,
  PhoiHopPhongBan = 2,
  PhatTrienBanThan = 3,
}

/** 1: Đang thực hiện, 2: Đã hủy */
export enum ETrangThaiKrMucTieu {
  DangThucHien = 1,
  DaHuy = 2,
}

/** 1: Đang lập, 2: Đang thực hiện, 3: Hoàn thành, 4: Đã hủy */
export enum ETrangThaiKrCongViec {
  DangLap = 1,
  DangThucHien = 2,
  HoanThanh = 3,
  DaHuy = 4,
}

export enum ELoaiTinTuc {
  ThongBao = 1,
  VanBan = 2,
}

export enum ETuongTacTinTuc {
  DaDoc = 1,
  Thich = 2,
}

export enum ECauHinhHeThong {
  ThoiGianMoDangKyLichLam = 'ThoiGianMoDangKyLichLam',
  ThoiGianDongDangKyLichLam = 'ThoiGianDongDangKyLichLam',
  SoPhutChoPhepDoiCa = 'SoPhutChoPhepDoiCa',
  SoPhutChoPhepVaoCaTruoc = 'SoPhutChoPhepVaoCaTruoc',
  SoPhutChoPhepVaoCaMuon = 'SoPhutChoPhepVaoCaMuon',
  SoPhutChoPhepRaCaSom = 'SoPhutChoPhepRaCaSom',
  SoPhutChoPhepRaCaMuon = 'SoPhutChoPhepRaCaMuon',
  SoPhutChoPhepVaoCaMuonTinhNuaCong = 'SoPhutChoPhepVaoCaMuonTinhNuaCong',
  SoPhutChoPhepRaCaSomTinhNuaCong = 'SoPhutChoPhepRaCaSomTinhNuaCong',
}
